import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { IListResponseMetadata } from '../../http.types';

@Component({
  selector: 'app-pager',
  templateUrl: 'pager.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
  ]
})
export class PagerComponent implements OnChanges {
  @Input()
  public meta: IListResponseMetadata;

  @Input()
  public maxPagesVisible: number = 5;

  @Output()
  public pageSelected: EventEmitter<number> = new EventEmitter();

  public pagesVisible: number[] = [];

  public get currentPage(): number {
    return this.meta.page;
  }

  public get lastPage(): number {
    return Math.ceil(this.meta.totalResults / this.meta.itemsPerPage);
  }

  public get isFirstPageVisible(): boolean {
    return this.pagesVisible[0] === 1;
  }

  public get isLastPageVisible(): boolean {
    return this.pagesVisible[this.pagesVisible.length - 1] === this.lastPage;
  }

  public ngOnChanges(): void {
    const totalPages = Math.ceil(this.meta.totalResults / this.meta.itemsPerPage);
    const leftOffset = Math.ceil(this.maxPagesVisible / 2 - 1);
    const rightOffset = Math.floor(this.maxPagesVisible / 2);
    const from = Math.max(1, Math.min(
      this.meta.page - leftOffset,
      totalPages - this.maxPagesVisible + 1,
    ));
    const to = Math.min(totalPages, Math.max(
      this.maxPagesVisible,
      this.meta.page + rightOffset
    ));

    this.pagesVisible = Array(to - from + 1)
      .fill(0)
      .map((val, idx) => idx + from);
  }

}
